import type { PdfSplitJobsState } from "features/pdfSplitJobsSlice";

export const PDF_SPLIT_JOBS_STORAGE_KEY = "calibrate_pdf_split_jobs_v1";

type Persisted = {
  v: 1;
  userId: number;
  jobs: PdfSplitJobsState["jobs"];
};

export function persistPdfSplitJobsState(
  userId: number | undefined,
  jobs: PdfSplitJobsState["jobs"],
): void {
  if (userId == null) return;
  try {
    const payload: Persisted = { v: 1, userId: Number(userId), jobs };
    localStorage.setItem(PDF_SPLIT_JOBS_STORAGE_KEY, JSON.stringify(payload));
  } catch {
  }
}

export function loadPdfSplitJobsState(): Omit<Persisted, "v"> | null {
  try {
    const raw = localStorage.getItem(PDF_SPLIT_JOBS_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Persisted;
    if (parsed?.v !== 1 || parsed.userId == null) return null;
    return { userId: Number(parsed.userId), jobs: parsed.jobs ?? {} };
  } catch {
    return null;
  }
}

export function clearPdfSplitJobsStorage(): void {
  try {
    localStorage.removeItem(PDF_SPLIT_JOBS_STORAGE_KEY);
  } catch {
  }
}
